import jqueryCookie from '../../../libraries/jquery.cookie';

export default function initEroticInfoBox () {
  jqueryCookie();
  if (!$.cookie('hideEroticInfoBox')) {
    $('.h3EroticInfoText .btn').on('click', function () {
      $.cookie('hideEroticInfoBox', 'true', { expires: 365, path: '/' });
      $('.h3EroticInfoText').hide();
    });
  }
}